<template>
  <div id="app">
    <Layout />
  </div>
</template>

<script>
import Layout from "@/components/Layout/Layout";

export default {
  name: "app",
  components: {
    Layout
  },
  mounted() {}
};
</script>

<style>
#app {
  width: 100vw;

  height: 100vh;
  height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  /*height: fill-available;*/

  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}
</style>
